import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Button from '../../../components/atoms/Button';
import Icon, { IconSizes, IconVariants } from '../../../components/foundations/Icon';
import css from './Section.css';

const Section = ({ icon, labelKey, description, children, addButton, errorKey }) => (
    <div className={css.section}>
        <div className={css.sectionHeader}>
            <div className={css.sectionLabel}>
                {icon && <Icon name={icon} size={IconSizes.X_SMALL} variant={IconVariants.DARK} />}
                <Translate id={labelKey} />
            </div>
            {description && (
                <div className={css.sectionDescription}>
                    <Translate id={description} />
                </div>
            )}
        </div>
        {errorKey ? (
            <div className={css.error}>
                <Translate id={errorKey} />
            </div>
        ) : (
            <>
                {children}
                {addButton && (
                    <Button
                        type="link"
                        Icon="plus"
                        iconVariant={IconVariants.ACTIVE}
                        iconSize={IconSizes.X_SMALL}
                        className={css.addButton}
                        {...addButton}
                    />
                )}
            </>
        )}
    </div>
);

Section.propTypes = {
    icon: PropTypes.string,
    labelKey: PropTypes.string.isRequired,
    description: PropTypes.string,
    children: PropTypes.node.isRequired,
    addButton: PropTypes.shape({
        text: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
        tooltipKey: PropTypes.string,
    }),
    errorKey: PropTypes.string,
};

export default Section;
